<template>
  <div>
    <Home
      @getUserInformation="getUserInformation"
      :userInfo="userInfo"
      v-if="
        state == 0 ||
          state == 8 ||
          state == 10 ||
          (!state && !token) ||
          (state == 3 && userInfo.reapply_time < new Date().getTime())
      "
      @openLoading="openLoading"
      @closeLoading="closeLoading"
    />
    <UserState
      v-if="
        state == 4 ||
          state == 2 ||
          state == 20 ||
          state == 6 ||
          (state == 3 && new Date().getTime() < userInfo.reapply_time) ||
          state == 12 ||
          state == 5
      "
    />
    <FrloanHome
      v-if="state == 22"
      :userInfo="userInfo"
      @getUserInformation="getUserInformation"
    />
    <RepaymentPage
      v-if="state == 7 || state == 9 || state == 11"
      @openLoading="openLoading"
      @closeLoading="closeLoading"
    />

    <van-overlay :show="loading">
      <div class="loadingIcon">
        <i class="el-icon-loading"></i>
        <p>
          loading...
        </p>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Home from "./home.vue";
import UserState from "./userState.vue";
import FrloanHome from "./frloanHome.vue";
import RepaymentPage from "./repayment.vue";
import { getInfor } from "../utils/api/h5page.js";
export default {
  name: "",
  components: {
    Home,
    UserState,
    FrloanHome,
    RepaymentPage,
  },
  props: {},
  data() {
    return {
      userInfo: {},
      state: null,
      token: "1",
      loading: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (localStorage.getItem("token")) {
      this.token = localStorage.getItem("token");
      this.getUserInformation();
    } else {
      this.token = "";
    }
    setTimeout(() => {
      window.client.record("login").then((r) => {
        console.log(r);
        localStorage.setItem("tokenKey", r);
      });
    }, 10);
  },
  methods: {
    // 获取用户订单信息
    getUserInformation() {
      this.openLoading();
      getInfor().then(({ data }) => {
        if (data.code == 0) {
          this.userInfo = data.data.loan_info;
          this.state = data.data.loan_info.order_status;
          localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
          this.$store.commit("setUserInfo", this.userInfo);
        }
        this.closeLoading();
      });
    },

    openLoading() {
      this.loading = true;
    },

    closeLoading() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.loadingIcon {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
  font-size: 0.35rem;
  color: #409eff;
  i {
    font-size: 0.65rem;
    margin-bottom: 0.2rem;
  }
}
</style>
